import useUsers from "../hooks/use-users";
import UsersPage from "../components/users-page";

const InternalUsersRoute: React.FC = () => {
  const { users, isLoading } = useUsers();

  return <UsersPage title="Users" type="internal" users={users} isLoadingUsers={isLoading} />;
};

export default InternalUsersRoute;
